import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { router } from './router.js';
import { TweaksPanel } from './components/tweaks/TweaksPanel.js';
import { useTweaks } from './components/tweaks/useTweaks.js';
import './styles/arenas.css';
import './styles/card.css';

export function App() {
  const arena = useTweaks((s) => s.arena);
  const themeIntensity = useTweaks((s) => s.themeIntensity);

  useEffect(() => {
    document.body.dataset.arena = arena;
    document.body.dataset.theme = themeIntensity;
  }, [arena, themeIntensity]);

  return (
    <>
      <RouterProvider router={router} />
      <TweaksPanel />
    </>
  );
}
